import axios from 'axios';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { getLocation } from "../locationHelper";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const SECRETKEY = 'SKILLED@2024' //process.env.REACT_SECRETKEY;

const client = axios.create({
    baseURL: API_ENDPOINT,
    headers: {
        'Content-Type': 'application/json',
    },
});

const clientWithoutToken = axios.create({
    baseURL: API_ENDPOINT,
    headers: {
        'Content-Type': 'application/json',
    },
});

client.interceptors.request.use(async (config) => {
    const requestConfig = config;
    const { headers } = config;

    let location;

    try {
      // 🔒 MUST allow location
      location = await getLocation();
    } catch (err) {
      alert(
        "Location access is required to use this system. Please enable location permission and reload the page."
      );

      // ❌ BLOCK ALL REQUESTS
      return Promise.reject({
        message: "Location permission required",
      });
    }

    const response = await axios.get(API_ENDPOINT+'guestToken').catch((error) => {
        
    });

    console.log('location',location);

    if(response?.data.redirect === '/dashboard'){
        Cookies.set('SangVendorLoggedIn', true);
        Cookies.set('SangVendorLoggedData', JSON.stringify(response?.data.data));
        window.location.href = '/dashboard';
    }

    requestConfig.headers = {
        ...headers,
        Authorization: response?.data?.accessToken ? `Bearer ${response.data.accessToken}`: "",
        "X-Latitude": location?.latitude || "",
        "X-Longitude": location?.longitude || "",
    };

    // requestConfig.headers = { ...headers, Authorization: `Bearer ${response.data.accessToken}` };
    return requestConfig;
}, (error) => {
    return Promise.reject(error);
});

client.interceptors.response.use(
    response => response,
    error => {
        const { response } = error;
        const originalRequest = error.config;
        if (response) {
            if (response.status === 500) {
                // do something here
            } else {
                return originalRequest;
            }
        }
        return Promise.reject(error);
    },
);
   
class GuestService {

    static checkOnline() {
        if (!navigator.onLine) {
            throw new Error('You are offline. Please check your internet connection.');
        }
    }

    static get(path = '') {
        this.checkOnline();
        return client({
            method: 'GET',
            url: path,
            headers: {},
        });
    }

    static post(path = '', data = {}, optionalHeader = {}) {
        this.checkOnline();
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRETKEY).toString();
        return client({
            method: 'POST',
            url: path,
            data: {encryptedData},
            headers: {...optionalHeader },
        });
    }

    static patch(path = '', data = {}) {
        this.checkOnline();
        return client({
            method: 'PATCH',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }

    static delete(path = '', data = {}) {
        this.checkOnline();
        return clientWithoutToken({
            method: 'DELETE',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }

    static put(path = '', data = {}) {
        this.checkOnline();
        return client({
            method: 'PUT',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }
}

export { GuestService };